<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <!-- Détails du usager -->
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Détails du usager</h4>
            <router-link to="/liste-usager" class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour
            </router-link>
          </div>

          <table class="table">
            <tbody>
              <tr>
                <td style="width: 20%;" rowspan="3" class="align-middle">
                  <a v-if="imagePreview" type="button" @click="openFile(imagePreview)">
                    <img style="height: 134px;" :src="imagePreview" class="img-thumbnail" alt="Image preview">
                  </a>
                  <div v-else class="text-center">
                    <div>
                      <i class="flaticon-camera fs-1"></i>
                    </div>
                  </div>
                </td>
                <td><strong>Nom:</strong></td>
                <td>{{ usager?.nom }}</td>
              </tr>
              <tr>
                <td><strong>Prenom:</strong></td>
                <td>{{ usager?.prenom }}</td>
              </tr>
              <tr>
                <td><strong>Sexe:</strong></td>
                <td>{{ usager?.sexe }}</td>
              </tr>
              <tr>
                <td><strong>Email:</strong></td>
                <td>{{ (usager && usager.email) ? usager.email : "Aucun email renseigné" }}</td>
              </tr>
              <tr>
                <td><strong>Numéro de téléphone:</strong></td>
                <td>{{ (usager && usager.tel) ? usager.tel : "Aucun numéro de téléphone renseigné" }}</td>
              </tr>
              <tr>
                <td><strong>NPI:</strong></td>
                <td>{{ (usager && usager.npi) ? usager.npi : "Aucun npi renseigné" }}</td>
              </tr>
              <tr>
                <td><strong>IFU:</strong></td>
                <td>{{ (usager && usager.ifu) ? usager.ifu : "Aucun ifu renseigné" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="autreFichiers.length > 0" class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="text-center">
            <a v-for="(media, index) in autreFichiers" :key="index" type="button" @click="openFile(media.url)">
              <img style="width: 200px; height: 200px;" :alt="'Autre Media' + index" class="rounded" :src="media.url">
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Fichier</h6>
            <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body px-4">
            <img v-if="isImage" :src="fileUrl" alt="Aperçu" class="preview-image" />
            <iframe v-else-if="isPdf" :src="fileUrl" class="preview-iframe"></iframe>
            <div v-else class="download-container">
              <img :src="fileUrl" class="rounded mx-auto d-block" alt="...">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_date, getUrlApiForFiles } from "@/utils/utils";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";
import modal from "bootstrap/js/dist/modal";
import axios from "axios";

export default defineComponent({
  name: "ViewUsager",
  setup: () => {
    const route = useRoute();
    const imagePreview = ref<string | null>(null);
    const usager = ref<any | null>(null);

    const modalMedia = ref<string | null>(null);
    const modalType = ref<'image' | 'pdf' | null>(null);
    const autreFichiers = ref<any[]>([]);

    const getUsager = async (id: string) => {
      return await ApiService.get("/usagers/" + id)
        .then(async ({ data }) => {
          const photo = data.data.medias.find((media: any) => media.typeFichier === "Photo");
          const lesPhotos = data.data.medias.map((photo)=>{
            if(photo.typeFichier === "Photo"){
              return photo;
            }
            
          })
          var autresFichiers: any[] = [];
          for (const media of data.data.medias) {
            if (media.typeFichier != "Photo") {
              const element = {
                url: await getUrlApiForFiles('Usagers', media.nomMedia),
                id: media.id
              }
              autresFichiers.push(element);
            }
          }
          if(photo){
            imagePreview.value = await getUrlApiForFiles('Usagers', photo.nomMedia);
          }
          
          autreFichiers.value = autresFichiers;
          usager.value = data.data;
        })
        .catch((err) => {
          if (axios.isAxiosError(err) && err.response) {
            error(err.response.data.message || err.message);
          } else {
            if (err instanceof Error) {
              error(err.message);
            } else {
              error(String(err));
            }
          }
        });
    }

    const openModal = (mediaName: string, type: 'image' | 'pdf') => {
      modalMedia.value = mediaName;
      modalType.value = type;
      const modalElement = document.getElementById('create-task');
      if (modalElement) {
        const modal = new Modal(modalElement);
        const modalInstance = new Modal(modalElement);
        modalInstance.show();
      }
    };

    const filteredMedia = computed(() => {
      return usager.value?.medias.filter(media => media.typeMedia === "Photo") || [];
    });

    const filteredAutre = computed(() => {
      return usager.value?.medias.filter(media => media.typeMedia === "Autre") || [];
    });

    onMounted(async () => {
      const id = route.params.id as string;
      if (id) {
        await getUsager(id);
      }
    });

    const showModal = ref(false);
    const fileUrl = ref("");
    const isImage = ref(false);
    const isPdf = ref(false);

    const openFile = (url) => {
      if (!url) return;
      const modalElement = document.getElementById('create-task');
      if (modalElement) {
        const modalInstance = new Modal(modalElement);
        modalInstance.show();
      }
      // Récupération de l'extension
      const extension = url.split(".").pop().toLowerCase();
      // Détection du type de fichier
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
      const pdfExtensions = ["pdf"];

      isImage.value = imageExtensions.includes(extension);
      isPdf.value = pdfExtensions.includes(extension);
      fileUrl.value = url;

      // Afficher le modal
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      fileUrl.value = "";
    };

    return {
      fileUrl,
      isImage,
      showModal,
      closeModal,
      isPdf,
      openFile,
      usager,
      getUsager,
      format_date,
      getUrlApiForFiles,
      filteredMedia,
      filteredAutre,
      openModal,
      autreFichiers,
      imagePreview,
      modalMedia,
      modalType
    };
  },
});
</script>
<style scoped>
.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 240px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>

<style>
/* Styles pour le modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 80%;
  max-width: 800px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  max-height: 500px;
  object-fit: contain;
}

.preview-iframe {
  width: 100%;
  height: 500px;
  border: none;
}

.download-container {
  text-align: center;
}

.download-link {
  display: inline-block;
  padding: 10px 15px;
  background: blue;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  margin-top: 20px;
}
</style>